// Auto-split from i18n.js — language: fr
export default {
    translation: {
        // routes & menus
        Dashboard: 'Tableau de bord',
        'Space Data': 'Espace',
        'Equipment Data': 'Équipement',
        'Meter Data': 'Mètre',
        'Tenant Data': 'Locataire',
        'Store Data': 'Boutique',
        'Shopfloor Data': 'Atelier',
        'Combined Equipment Data': 'Équipement combiné',
        'Auxiliary System': 'Système auxiliaire',
        Microgrid: 'Micro-réseau',
        'Energy Storage Power Station': 'Centrale électrique',
        'Photovoltaic Power Station': 'Centrale électrique',
        'Fault Alarm': 'Alarme de panne',
        Monitoring: 'Surveillance',
        'Advanced Reporting': 'Rapports avancés',
        'Knowledge Base': 'Base de connaissances',
        'Energy Category Data': 'Catégorie d’énergie',
        'Energy Item Data': 'Élément d’énergie',
        Carbon: 'Émissions de CO2',
        Cost: 'Coût',
        Output: 'Sortie',
        Income: 'Revenu',
        Efficiency: 'Efficacité',
        Load: 'Charger',
        Statistics: 'Statistiques',
        'Batch Analysis': 'Analyse des lots',
        Saving: 'ÉpargneⒺ',
        Plan: 'PlanⒺ',
        Prediction: 'PredictionⒺ',
        'Production': 'Production',
        'Space Production': 'Space Production',
        'Equipment Tracking': 'Suivi de l’équipement',
        'Equipment Comparison': 'Comparaison d’équipement',
        'Shopfloor Comparison': 'Comparaison d’équipement',
        'Store Comparison': 'Comparaison',
        'Space Comparison': 'Comparaison',
        'Combined Equipment Comparison': 'Comparaison d’équipement',
        'Tenant Comparison': 'Comparaison des locataires',
        'Environment Monitor': 'Moniteur d’environnement',
        'Meter Energy': 'Compteur d’énergie',
        'Meter Prediction': 'Prédiction du compteurⒺ',
        'Virtual Meter Prediction': 'Prédiction du compteur virtuelⒺ',
        'Offline Meter Prediction': 'Prédiction du compteur hors ligneⒺ',
        'Meter Carbon': 'Computer Émissions de CO2',
        'Meter Cost': 'Compteur Coût',
        'Meter Trend': 'Compteur Tendance',
        'Meter Realtime': 'Compteur en temps réel',
        'Meter Saving': 'Compteur ÉconomieⒺ',
        'Meter Plan': 'plan de compteurⒺ',
        'Master Meter Submeters Balance': 'Balance des sous-compteurs du compteur maître',
        'Meter Batch Analysis': 'Compteur Analyse des lots ',
        'Meter Comparison': 'Compteurs Comparaison',
        'Meter Tracking': 'Compteurs Suivi',
        'Virtual Meter Saving': 'Compteur Virtuel ÉconomieⒺ',
        'Virtual Meter Plan': 'Plan de compteur virtuelⒺ',
        'Virtual Meter Energy': 'Compteur Virtuel d’énergie',
        'Virtual Meter Carbon': 'Compteur Virtuel Émissions de CO2',
        'Virtual Meter Cost': 'Compteur Virtuel Coût',
        'Virtual Meter Batch Analysis': 'Analyse par lots de tables virtuelles',
        'Virtual Meter Comparison': "Comparaison de compteurs virtuels",
        'Offline Meter Energy': 'Compteur Hors Ligne d’énergie',
        'Offline Meter Carbon': 'Compteur Hors Ligne Émissions de CO2',
        'Offline Meter Cost': 'Compteur Hors Ligne Coût',
        'Offline Meter Batch Analysis': 'Analyse des lots de compteurs hors ligne',
        'Offline Meter Saving': 'Compteur Hors Ligne ÉconomieⒺ',
        'Offline Meter Plan': 'Plan de compteur hors ligneⒺ',
        'Offline Meter Input': 'Compteur Hors Ligne Entrée',
        'Tenant Bill': 'Locataire Facture',
        'Energy Flow Diagram': 'Diagramme de flux d’énergie',
        'Distribution System': 'Réseau de distribution',
        'SVG System': 'Systèmes de visualisation SCADA Ⓔ',
        'Faults Data': 'Défauts',
        'Space Equipments': 'Espace Équipements',
        'Combined Equipments': 'Combinés Équipements',
        'Energy Storage Power Station List': 'List',
        'Energy Storage Power Station Details': 'Details',
        'Energy Storage Power Station Reporting': 'Reporting',
        'Energy Storage Power Station Alarm': 'Alarm',
        'Energy Storage Power Station Maintenance': 'Maintenance',
        'Enter Production': 'Enter Production',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': 'Multiple Power Stations',
        'Multiple Energy Storage Power Stations Dashboard': 'Dashboard',
        'Multiple Energy Storage Power Stations List': 'List',
        'Single Energy Storage Power Station': 'Single Power Station',
        'Single Energy Storage Power Station Dashboard': 'Dashboard',
        'Single Energy Storage Power Station Details': 'Details',
        'Single Energy Storage Power Station Fault Alarm': 'Fault Alarm',
        'Energy Storage Power Station Reports': 'Power Station Reports',
        'Energy Storage Power Station Reports Energy': 'Energy',
        'Energy Storage Power Station Reports Revenue': 'Revenue',
        'Energy Storage Power Station Reports Parameters': 'Parameters',
        'Photovoltaic Power Station List': 'List',
        'Photovoltaic Power Station Details': 'Details',
        'Photovoltaic Power Station Reporting': 'Reporting',
        'Photovoltaic Power Station Alarm': 'Alarm',
        'Photovoltaic Power Station Maintenance': 'Maintenance',
        'Multiple Photovoltaic Power Stations': 'Multiple Power Stations',
        'Multiple Photovoltaic Power Stations Dashboard': 'Dashboard',
        'Multiple Photovoltaic Power Stations List': 'List',
        'Single Photovoltaic Power Station': 'Single Power Station',
        'Single Photovoltaic Power Station Dashboard': 'Dashboard',
        'Single Photovoltaic Power Station Details': 'Details',
        'Single Photovoltaic Power Station Fault Alarm': 'Fault Alarm',
        'Photovoltaic Power Station Reports': 'Power Station Reports',
        'Photovoltaic Power Station Reports Energy': 'Energy',
        'Photovoltaic Power Station Reports Revenue': 'Revenue',
        'Photovoltaic Power Station Reports Parameters': 'Parameters',
        'Work Order': 'Work Order',
        'Work Order Installation': 'Installation',
        'Work Order Repair': ' Repair',
        'Work Order Inspection': 'Inspection',
        'Total Number of Work Orders': 'Nombre total de bons de travail',
        'Number of New Work Orders': 'Nombre de nouveaux bons de travail',
        'Number of Inprogress Work Orders': 'Nombre de bons de travail en cours',
        'Number of Done Work Orders': 'Nombre de bons de travail terminés',
        'Fuel Indicator': 'Consommation de carburant',
        'Charge Energy Indicator': 'Énergie de charge',
        'Discharge Energy Indicator': 'Énergie de décharge',
        'Charge Cost Indicator': 'Coût de charge',
        'Discharge Revenue Indicator': 'Revenu de décharge',
        'HVAC': 'HVAC',
        'Fire Control': 'Lutte contre les incendies',
        'Store Dashboard': 'Tableau de Bord des Magasins',
        'Comprehensive overview of store energy performance': 'Aperçu complet de la performance énergétique des magasins',
        'Total Stores': 'Nombre Total de Magasins',
        'Total Area': 'Surface Totale',
        'Active Meters': 'Compteurs Actifs',
        'Active Alerts': 'Alertes Actives',
        'Total Energy Consumption': 'Consommation Totale d\'Énergie',
        'Carbon Emissions': 'Émissions de Carbone',
        'Current Period': 'Période Actuelle',
        'Energy Consumption by Category': 'Consommation d\'Énergie par Catégorie',
        'Cost Distribution by Category': 'Distribution des Coûts par Catégorie',
        'Monthly Energy & Cost Trends': 'Tendances Mensuelles d\'Énergie et de Coûts',
        'Top 5 Energy Consuming Stores': 'Top 5 des Magasins les Plus Consommateurs',
        'Energy Category Details': 'Détails des Catégories d\'Énergie',
        'Store Performance Overview': 'Aperçu de la Performance des Magasins',
        'YoY Change': 'Variation Annuelle',
        'Per m²': 'Par m²',
        'Usage Intensity': 'Intensité d\'Utilisation',
        'Dashboard data loaded successfully': 'Données du tableau de bord chargées avec succès',
        'Failed to load dashboard data': 'Échec du chargement des données du tableau de bord',
        'Store Name': 'Nom du magasin',
        'Store Area': 'Surface du magasin',
        'Energy Consumption': 'Consommation d\'énergie',
        'Consumption': 'Consommation',
        'last period': 'période précédente',
        // Tenant Dashboard
        'Tenant Dashboard': 'Tableau de Bord des Locataires',
        'Comprehensive overview of tenant energy performance': 'Aperçu complet de la performance énergétique des locataires',
        'Total Tenants': 'Total des Locataires',
        'Tenant Performance Overview': 'Aperçu de la Performance des Locataires',
        'Tenant Name': 'Nom du Locataire',
        'Tenant Area': 'Surface du Locataire',
        'Tenant Type': 'Type de Locataire',
        // Equipment Dashboard
        'Equipment Dashboard': 'Tableau de bord des équipements',
        'Total Equipments': 'Total des équipements',
        'Equipment Performance Overview': 'Aperçu des performances des équipements',
        'Equipment Name': 'Nom de l’équipement',
        'Equipment Type': 'Type d’équipement',
        'Total Energy': 'Énergie totale',
        'Total Sensors': 'Total des capteurs',
        'Increment Rate': 'Taux d’incrément',
        // Shopfloor Dashboard
        'Total Shopfloors': 'Nombre total d\'ateliers',
        'Shopfloor Performance Overview': 'Aperçu des performances des ateliers',
        'Shopfloor Name': 'Nom de l\'atelier',
        'Shopfloor Area': 'Surface de l\'atelier',
        // Combined Equipment Dashboard
        'Total Combined Equipments': 'Nombre total d\'équipements combinés',
        'Combined Equipment Performance Overview': 'Aperçu des performances des équipements combinés',
        'Combined Equipment Name': 'Nom de l\'équipement combiné',
        'Associated Equipments': 'Équipements associés',

        // Dashboard
        'Welcome to QiXuan': 'Bienvenue chez QiXuan',
        'An Industry Leading Energy Management System': 'Un système de gestion de l’énergie leader de l’industrie',
        "This Year's Consumption CATEGORY VALUE UNIT": 'La consommation de cette année {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": 'Les coûts de cette année {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": 'Ce mois-ci Consumption {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": 'Coûts de ce mois-ci {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            'Consommation {{CATEGORY}} {{VALUE}} {{UNIT}} à la même période l’an dernier',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year':
            'Coûts {{CATEGORY}} {{VALUE}} {{UNIT}} à la même période l’an dernier',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} Consommation {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} Coûts {{UNIT}}',
        // Entities
        Space: 'Espace',
        Equipment: 'Équipements',
        Meter: 'Compteur',
        'Offline Meter': 'Compteur Hors Ligne',
        'Virtual Meter': 'Compteur Virtuel',
        Tenant: 'Locataire',
        Store: 'Boutique',
        Shopfloor: 'Atelier',
        'Combined Equipment': 'Équipement combiné',
        'Cost Center': 'Centre de coûts',
        Name: 'Nom',
        DisplayName: 'Montrer Nom',
        UserName: 'Utilisateur Nom',
        Description: 'Description',
        'Energy Category': 'Catégorie d’énergie',
        'Child Spaces': 'Espaces enfants',
        'Associated Equipment': 'Équipement connexe',
        //Energy Categories
        Electricity: 'Électricité',
        Water: 'Eau',
        'Natural Gas': 'Naturel Gaz',
        // SidePanelModal
        Settings: 'Paramètres',
        'Set your own customized style': 'Définissez votre propre style personnalisé',
        'Color Scheme': 'Couleur Schéma',
        'Choose the perfect color mode for your app': 'Choisissez le mode de couleur parfait pour votre application',
        Light: 'Lumière',
        Dark: 'Sombre',
        'RTL Mode': 'RTL Mode',
        'Switch your language direction': 'Changez de langue',
        'Fluid Layout': 'Disposition fluide',
        'Toggle container layout system': 'Système de disposition de conteneur bascule',
        'Navigation Position': 'Navigation Position',
        'Vertical': 'Verticale',
        'Top': 'Le top',
        'Combo': 'Combinaison',
        'Transparent': 'Transparent',
        'Inverted': 'Inversé',
        'Card': 'Carte',
        'Vibrant': 'Animé',
        'Select a suitable navigation system for your web application':
            'Sélectionnez un système de navigation adapté à votre application Web',
        'Vertical Nav': 'Navigation verticale',
        'Top Nav': 'Navigation supérieure',
        'Vertical Navbar Style': 'Style de barre de navigation verticale',
        'Switch between styles for your vertical navbar':
            'Basculer entre les styles pour votre barre de navigation verticale',
        Language: 'Langue',
        'Switch between languages': 'Basculer entre les langues',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Русский',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中文',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': 'Vous aimez ce que vous voyez ?',
        'Get QiXuan now': 'Avoir QiXuan Maintenant',
        Purchase: 'Édition Enterprise',
        ContactInfo: 'Coordonnees',
        ProductWebsite: 'Site produit',
        CompanyWebsite: "Site de l'entreprise",
        SalesPhone: 'Telephone commercial',
        // Query Panel
        'Base Period Begins': 'Base Période Commence',
        'Base Period Ends': 'Base Période Finit',
        'Comparison Types': 'Comparaison Types',
        'Year-Over-Year': 'D’une année à l’autre',
        'Month-On-Month': 'Mois sur mois',
        'Free Comparison': 'Libre Comparaison',
        'None Comparison': 'Aucun Comparaison',
        'Reporting Period Begins': 'Rapports Période Commence',
        'Reporting Period Ends': 'Rapports Période Finit',
        '(Optional)': '(Optionnel)',
        'Period Types': 'Période Types',
        Yearly: 'Annuel',
        Monthly: 'Mensuel',
        Weekly: 'Hebdomadaire',
        Daily: 'Quotidien',
        Hourly: 'Horaire',
        Submit: 'Envoyer',
        'Input Energy Category': 'Entrée Énergie Catégorie',
        'Output Energy Category': 'Sortie Énergie Catégorie',
        'Fraction Parameter': 'Fraction Paramètre',
        Search: 'Rechercher',
        //DateRangePicker
        sunday: 'Su',
        monday: 'Mo',
        tuesday: 'Tu',
        wednesday: 'We',
        thursday: 'Th',
        friday: 'Fr',
        saturday: 'Sa',
        ok: 'D’ACCORD',
        today: 'Aujourd’hui',
        yesterday: 'Hier',
        hours: 'Heures',
        minutes: 'Compte-rendu',
        seconds: 'Secondes',
        last7Days: '7 derniers jours',
        tomorrow: 'Demain',
        dayAfterTomorrow: 'Après-demain',
        next7Days: '7 jours suivants',
        'Select Date Range': 'Sélectionnez une plage de dates',
        //Card Summaries and Line Charts
        'Base Period': 'Base Période',
        'Reporting Period': 'Rapports Période',
        'Per Unit Area': 'Par unité de surface',
        'Per Capita': 'Per Capita',
        'Per Unit Production': 'Production unitaire',
        Baseline: 'Ligne de base',
        Actual: 'Effective',
        'Baseline Value - Actual Value': 'Ligne de base - Effective',
        'Average Load': 'Moyen Charger',
        'Maximum Load': 'Maximum Charger',
        'Load Factor': 'Charger Facteur',
        'Ratio of Average Load to Maximum Load': 'Rapport entre la charge moyenne et la charge maximale',
        'Carbon Dioxide Emissions by Energy Category': 'Émissions de dioxyde de carbone par catégorie d’énergie',
        'Costs by Energy Category': 'Coûts par catégorie d’énergie',
        'Incomes by Energy Category': 'Revenus par catégorie d’énergie',
        'Electricity Consumption by Time-Of-Use': 'Consommation d’électricité selon l’heure de consommation',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use':
            'Électricité Émissions de dioxyde de carbone selon l’heure de consommation',
        'Electricity Cost by Time-Of-Use': 'Coût de l’électricité selon l’heure de consommation',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}} {{UNIT}} Consommation par éléments énergétiques',
        'Ton of Standard Coal by Energy Category': 'Tonne de charbon standard (TCE) par catégorie d’énergie',
        'Ton of Carbon Dioxide Emissions by Energy Category':
            'Tonnes d’émissions de dioxyde de carbone (TCO2E) par catégorie d’énergie',
        'Reporting Period Consumption CATEGORY UNIT': 'Rapports Période Consommation {{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} Rapports Période Consommation {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Rapports Période Consommation {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': 'Rapports Période Consommation {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': 'Reporting Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': 'Base Period Production {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': 'Base Période Consommation {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': 'Rapports Période Consommation {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT':
            'Rapports Période Consommation {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT':
            'Base Période Consommation {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': 'Espace enfant Proportion par catégorie d’énergie {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': 'Espace enfant Total Proportion',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT':
            'Rapports Période Émissions de dioxyde de carbone {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Rapports Période Émissions de dioxyde de carbone {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            'Base Période Émissions de dioxyde de carbone {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': 'Rapports Période Coûts {{CATEGORY}} {{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': 'Rapports Période Coûts {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': 'Base Période Coûts {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': 'Rapports Période Sortie {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT': '{{EQUIPMENT}} Rapports Période Sortie {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} Rapports Période Sortie {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': 'Rapports Période Sortie {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': 'Base Période Sortie {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': 'Rapports Période Revenu {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': 'Rapports Période Revenu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': 'Base Période Revenu {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': 'Rapports Période Total Revenu {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': 'Rapports Période Efficacité Cumulative {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} Rapports Période Efficacité Cumulative {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Rapports Période Efficacité Globale Cumulée {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Rapports Période Efficacité Globale Cumulée {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} Base Période Efficacité Globale Cumulée {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': 'Instantané Efficacité {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} Instantané Efficacité {{UNIT}}',
        'Equipment Efficiency Indicator': 'Indicateur d’efficacité énergétique de l’équipement',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} Instantané Complet Efficacité {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': 'Rapports Période Cumulatif Efficacité {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT':
            'Rapports Période Cumulatif Efficacité {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': 'Base Période Cumulatif Efficacité {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT':
            'Base Période Cumulatif Efficacité {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': 'Base Période {{CATEGORY}} Maximum Charger {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': 'Rapports Période {{CATEGORY}} Maximum Charger {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': 'Rapports Période {{CATEGORY}} Moyen Charger {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': 'Rapports Période{{CATEGORY}} Charger Facteur',
        'Base Period CATEGORY Average Load VALUE UNIT': 'Base Période {{CATEGORY}} Moyen Charger {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': 'Rapports Période {{CATEGORY}} Moyen Valeur {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': 'Rapports Période {{CATEGORY}} Maximum Valeur {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': 'Rapports Période {{CATEGORY}} Minimum Valeur {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': 'Rapports Période {{CATEGORY}} Arithmétique Méchant {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': 'Rapports Période {{CATEGORY}} Médian (Milieu Valeur) {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': 'Rapports Période {{CATEGORY}} Échantillon Standard Déviation {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': 'Rapports Période {{CATEGORY}} Échantillon Variance {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT':
            'Rapports Période Épargne {{CATEGORY}} (Ligne de base - Effective) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT':
            'Rapports Période Diminué {{CATEGORY}} (Ligne de base - Effective) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': 'Rapports Période Épargne {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': 'Base Période Épargne {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT':
            'Rapports Période Maître Compteur Consommation {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT':
            'Rapports Période Maître Compteur Consommation {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT':
            'Rapports Période Sous-Compteur Consommation {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            'Rapports Période Sous-Compteur Consommation {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': 'Rapports Période Difference {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': 'Rapports Période Pourcentage Difference',
        'Reporting Period Difference CATEGORY VALUE UNIT': 'Rapports Période Difference {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': 'Faute Liste',
        'Reporting Period Number of Fault VALUE': 'Rapports Période Nombre de Faute {{VALUE}}',
        'All Faults': 'Tout Fautes',
        'Space Faults': 'Espace Fautes',
        'Number of All Faults': 'Nombre de Tout Fautes',
        'Number of Space Faults': 'Nombre de Espace Fautes',
        'Total Number of Faults': 'Total Number of Faults',
        'Number of New Faults': 'Number of New Faults',
        'Number of Inprogress Faults': 'Number of Inprogress Faults',
        'Number of Done Faults': 'Number of Done Faults',
        //Data Panels
        'Ton of Standard Coal': 'Tonne de Charbon standard',
        'Ton of Carbon Dioxide Emissions': 'Tonne de Émissions de dioxyde de carbone',
        'Carbon Emissions Per Unit Of Energy Consumption': 'Émissions de carbone par unité de consommation d\'énergie',
        'Operating Characteristic Curve': 'Courbe des caractéristiques de travail',
        Tariff: 'Tarif',
        'Detailed Data': 'Détaillé Données',
        'Child Spaces Data': 'Enfant Espaces Données',
        'Associated Equipment Data': 'Associé Équipement Données',
        'This Year': 'Cette année',
        'The Same Period Last Year': 'La même période l’an dernier',
        'This Month': 'Ce mois-ci',
        'This Day': 'Ce jour',
        Total: 'Total',
        'No data found': 'Non Données fonder',
        Export: 'Exportation',
        'AI Analysis': 'Analyse IA',
        Datetime: 'Datetime',
        'Time-Of-Use Type': 'Heure d’utilisation Type',
        'Top-Peak': 'Top-Peak',
        'On-Peak': 'On-Peak',
        'Mid-Peak': 'Mid-Peak',
        'Off-Peak': 'Off-Peak',
        'Deep': 'Deep-Valley',
        Percentage: 'Pourcentage',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': 'Tendance dans la dernière heure d’Energy Value Point',
        Circuit: 'Circuit',
        Point: 'Point',
        'Realtime Value': 'Temps réel Valeur',
        //Meter Tracking
        'Meter List': 'Compteur Liste',
        'Edit Meter': 'Éditer',
        'Start Value': 'Commencer Valeur',
        'End Value': 'Fin Valeur',
        'Difference Value': 'Différence Valeur',
        'Start Integrity Rate': 'Commencer Intégrité Taux(%)',
        'End Integrity Rate': 'Fin Intégrité Taux(%)',
        'Full Integrity Rate': 'Plein Intégrité Taux(%)',
        'Start Integrity Rate Description': "Taux d'intégrité des données de début: Proportion des compteurs ayant obtenu avec succès des lectures de consommation d'énergie au moment de début parmi tous les compteurs au cours de la période statistique",
        'End Integrity Rate Description': "Taux d'intégrité des données de fin: Proportion des compteurs ayant obtenu avec succès des lectures de consommation d'énergie au moment de fin parmi tous les compteurs au cours de la période statistique",
        'Full Integrity Rate Description': "Taux d'intégrité des données complet: Proportion des compteurs ayant obtenu avec succès des lectures de consommation d'énergie aux moments de début et de fin parmi tous les compteurs au cours de la période statistique",
        //Equipment Tracking
        'Equipment List': 'Équipement Liste',
        'Edit Equipment': 'Éditer',
        //Profile Dropdown
        Feedback: 'Rétroaction',
        'Account Settings': 'Compte Paramètres',
        Logout: 'Déconnexion',
        //Authentication
        'Log in': "S'identifier",
        'Email address': 'Messagerie électronique adresse',
        'Phone Number': 'Numéro de téléphone',
        Password: 'Mot de passe',
        CaptchaCode: 'Captcha',
        Refresh: 'Rafraîchir',
        'Remember me': 'Se souvenir me',
        'Logged in as ': 'Connecté dans comme ',
        'Forgot Password?': 'Oublié Mot de passe?',
        'Forgot your password?': 'Oublié votre Mot de passe?',
        "Enter your email and we'll send you a reset link":
            'Entrez votre adresse e-mail et nous vous enverrons un lien de réinitialisation',
        "Enter your email and we'll send you a registration link":
            'Entrez votre adresse e-mail et nous vous enverrons un lien d’inscription',
        'Reset Password': 'Réinitialisation Mot de passe',
        'Thanks for using QiXuan!': 'Merci d’utiliser QiXuan!',
        'You are now successfully signed out': 'Vous êtes maintenant déconnecté avec succès',
        'Return to Login': 'Rendre À Connectez-vous',
        'Please check your email!': 'S’il vous plaît vérifier votre e-mail!',
        'An email has been sent to ': 'Un e-mail a été envoyé à',
        'Please click on the included link to reset your password':
            'Veuillez cliquer sur le lien inclus pour réinitialiser votre mot de passe',
        'Please click on the included link to register your account':
            'Veuillez cliquer sur le lien inclus pour enregistrer votre compte',
        'An email with password reset link is sent to ':
            'Un e-mail avec un lien de réinitialisation du mot de passe est envoyé à ',
        'Change Password': 'Changement Mot de passe',
        'Old Password': 'Vieux Mot de passe',
        'New Password': 'Nouveau Mot de passe',
        'Confirm Password': 'Confirmer Mot de passe',
        'Update Password': 'Mettre à jour Mot de passe',
        'Password has been changed!': 'Le mot de passe a été changé!',
        'Verification code has been sent to your inbox. \
  Please copy it to the input box below..':
            'Le code de vérification a été envoyé dans votre boîte de réception. \
  Veuillez le copier dans la zone de saisie ci-dessous.',
        'New to QiXuan': 'Nouveau sur QiXuan',
        'Create an account': 'Créer un compte',
        'EMAIL Account registration successful': '{{EMAIL}} Compte inscription réussi',
        'Thanks for verifying your account!': 'Merci d’avoir vérifié votre compte!',
        'Your code is': 'Votre code est',
        'Send verification code': 'Envoyer le code de vérification',
        'Please wait for NUMBER seconds': 'Veuillez patienter {{NUMBER}} Secondes',
        'Password reset': 'Mot de passe réinitialisation',
        'Please wait for approval': 'Veuillez attendre l’approbation',
        //notification
        Notifications: 'Notifications',
        'Mark all as read': 'Marquer tout comme lu',
        'View all': 'Tout',
        'Notification New': 'NOUVEAU',
        'Notification Earlier': 'PLUS TÔT',
        'Notification List': 'Liste des notifications',
        'Bulk actions': 'Actions groupées',
        'Notification Subject': 'Subject',
        'Notification Created Datetime': 'Date/heure de création',
        'Notification Priority': 'Priorité',
        'Notification Message': 'Message',
        'Notification Status': 'Statut',
        'Notification Mark As Read': 'Marquer comme lu',
        'Notification Mark As Acknowledged': 'Reconnaître',
        'Notification Low': 'Bas',
        'Notification Medium': 'Douleur moyenne',
        'Notification High': 'Haut',
        'Notification Critical': 'Critique',
        'Notification Unread': 'Non lu',
        'Notification Read': 'Lire',
        'Notification Acknowledged': 'Reconnu',
        'Notification Archive': 'Archiver',
        'Notification Delete': 'Supprimer',
        'Notification Apply': 'Appliquer',
        'Notification Start Datetime': 'Dateheure de début',
        'Notification End Datetime': 'Dateheure de fin',
        'Notification Update Datetime': 'Mettre à jour la date et l\'heure',
        //Monitoring
        'Run Commands': 'Exécuter des commandes',
        'Pin Code': 'Code PIN',
        'Unlock': 'Ouvrir',
        'Set Value': 'Définir la valeur',
        'Fault Alarms': 'Alarmes de panne',
        'Instantaneous Efficiency VALUE UNIT': 'Instantané Efficacité {{VALUE}} {{UNIT}}',
        'Communication Online': 'En ligne',
        'Communication Offline': 'Hors-ligne',
        'Equipment Status': 'État de l’équipement',
        'Equipment Running': 'Course',
        'Equipment Stopped': 'Arrêté',
        'Show Up to': 'Présentez-vous à',
        All: 'Tout',
        'FROM - TO of TOTAL': 'Affichage actuel {{FROM}} - {{TO}} total {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': 'Énergie des microréseaux',
        'Microgrid Revenue': 'Revenus des microréseaux',
        'Microgrid Carbon': 'Carbone des microréseaux',
        'Photovoltaic Generation': 'Génération photovoltaïque',
        'EV Charger Consumption': 'Consommation des chargeurs EV',
        'Load Consumption': 'Consommation de charge',
        'Grid Buy': 'Achat du réseau',
        'Grid Sell': 'Vente au réseau',
        'EV Charger': 'Chargeur pour véhicule électrique',
        'Heat Pump': 'Pompe à chaleur',
        'Photovoltaic': 'Photovoltaïque',
        'PCS Run State': 'État de fonctionnement du PCS',
        'PCS Unknown': 'Inconnu',
        'PCS Initializing': 'Initialisation en cours',
        'PCS Standby': 'Articles de rechange',
        'PCS Shutdown': 'Temps d’arrêt',
        'PCS Fault': 'La faute',
        'PCS Running': 'Courir',
        'Battery Power': 'Puissance de la batterie',
        'Photovoltaic Power': 'Puissance photovoltaïque',
        'Grid Power': 'Puissance du réseau électrique',
        'Load Power': 'Puissance de charge',
        Reporting: 'Rapport',
        Maintenance: 'Réparation',
        'Serial Number': 'Numéro de série',
        Address: 'Adresse',
        'Postal Code': 'Code Postal',
        'Rated Capacity': 'Capacité nominale',
        'Rated Power': 'Puissance nominale',
        Latitude: 'Latitude',
        Longitude: 'Longitude',
        'Strategy Management': 'Gestion des politiques',
        'Charging Schedule': 'Charging Schedule',
        'Charge Start Time': 'Charge début temps',
        'Charge End Time': 'Charge end Time',
        'Discharge Start Time': 'Le Discharge start time',
        'Discharge End Time': 'Le Discharge end Time',
        'Total Rated Power': 'Puissance totale',
        'Total Rated Capacity': 'Capacité nominale totale',
        "Today's Charge": "Volume de charge aujourd'hui",
        "Today's Discharge": "Décharge aujourd'hui",
        "Today's Generation": "La production d’électricité d’aujourd’hui",
        'Total Fuel Consumption': 'Total Fuel Consumption',
        'Total Charge': 'Charge totale',
        'Total Discharge': 'décharge totale',
        'Total Generation': 'Génération totale',
        'Total Revenue': 'Revenu total',
        'Total Photovoltaic Generation': 'Génération photovoltaïque totale',
        'Total EV Charger Consumption': 'Consommation totale des chargeurs EV',
        'Total Load Consumption': 'Consommation totale de charge',
        'Total Grid Buy': 'Achat total du réseau',
        'Total Grid Sell': 'Vente totale au réseau',
        'Total Efficiency': 'Efficacité totale',
        'Discharge Achievement Rate': 'Taux de réussite de la décharge',
        // Revenue Indicator
        "Today's Cost": "Today's Cost",
        "Today's Income": "Today's Income",
        "Total Cost": "Total Cost",
        "Total Income": "Total Income",
        "Today's Revenue": "Today's Revenue",

        'Revenue Ranking': 'Classement des revenus',
        'Efficiency Ranking': 'Classement d\'efficacité',
        'Charge Ranking': 'Classement de la capacité de charge',
        'Discharge Ranking': 'Classement de décharge',
        'Number of Microgrids': 'Nombre de micro-réseaux',
        'Number of Power Stations': 'Nombre de centrales électriques',
        'Microgrid List': 'Liste des microréseaux',
        'Select Microgrid': 'Sélectionner le microréseau',
        'Previous Page': 'Page précédente',
        'Next Page': 'Page suivante',
        '7 Days': '7 jours',
        'Charge UNIT': 'Charge {{UNIT}}',
        'Discharge UNIT': 'décharge {{UNIT}}',
        'Generation UNIT': 'produire de l\'électricité {{UNIT}}',
        'Energy Indicator': 'énergétique',
        'Revenue Indicator': 'rendement',
        'Carbon Indicator': 'carbone',

        // Energy Storage Power Station
        'Battery Operating State': 'État de fonctionnement de la batterie',
        'Battery State': 'État de la batterie',
        'Battery Unknown': 'Inconnu',
        'Battery Stopped': 'A cessé',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': 'La faute', // 1
        'Battery Warning': 'Avertissement', // 2
        'Battery Standby': 'Articles de rechange', // 3
        'Battery Prohibit DisCharging': 'Interdiction de désinstaller', // 4
        'Battery Prohibit Charging': 'Interdiction de charger', // 5
        'Battery Normal': 'Typiquement', // 6
        'Battery Charging': 'En charge', // 7
        'Battery Discharging': 'Dans la décharge', // 8
        'Battery Idle': 'Idle', // 9
        'Phase of Lifecycle': 'Phases du cycle de vie',
        'Use Phase': 'Phase d\'utilisation',
        'Commissioning Phase': 'Phase de mise en service',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': 'Phase d\'installation',
        'Device Status': 'État de l\'appareil',
        'Basic Information': 'Informations de base',
        'Gateway': 'Gateway',
        'Grid Meter': 'Grid Meter',
        'Load Meter': 'Load Meter',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': 'onduleurs',
        'Invertor Run State': 'État de fonctionnement',
        'Invertor Unknown': 'Inconnu',
        'Invertor Initializing': 'Initialisation en cours',
        'Invertor Standby': 'Articles de rechange',
        'Invertor Shutdown': 'Temps d’arrêt',
        'Invertor Fault': 'La faute',
        'Invertor Running': 'Courir',

        //Advanced Reporting & Knowledge base
        'Created Datetime': 'Créé Datetime',
        'File Format': 'Lime Format',
        'File Size': 'Lime Taille',
        Uploader: 'Téléchargeur',
        //Error
        "The page you're looking for is not found": 'La page que vous recherchez est introuvable',
        "Make sure the address is correct and that the page hasn't moved. ":
            'Assurez-vous que l’adresse est correcte et que la page n’a pas été déplacée. ',
        'If you think this is a mistake,': 'Si vous pensez que c’est une erreur,',
        'contact us': 'Contactez-nous',
        'Take me home': 'Ramenez-moi à la maison',
        'Whoops, something went wrong!': 'Whoops, quelque chose s’est mal passé!',
        'Try refreshing the page, or going back and attempting the action again. ':
            'Essayez d’actualiser la page, ou revenir en arrière et tenter à nouveau l’action. ',
        'If this problem persists,': 'Si ce problème persiste,',
        'Captcha Error': 'Captcha Erreur',
        'Confirm Password Error': 'Le mot de passe de confirmation ne correspond pas',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            'Il semble que vous ayez cliqué \
  sur un lien de réinitialisation de mot de passe non valide. Veuillez réessayer.',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            'Il semble que vous ayez \
  cliqué sur un lien de compte d’inscription non valide. Veuillez réessayer..',
        //Tenant Bill
        'Lease Contract Number': 'Bail Contrat Nombre',
        Download: 'Télécharger',
        Print: 'Imprimer',
        'Payment Notice': 'Paiement Remarquer',
        'Bill To': 'Facture À',
        'Bill Number': 'Facture Nombre',
        'Bill Date': 'Facture Date',
        'Payment Due Date': 'Paiement Due Date',
        'Amount Payable': 'Quantité Payable',
        'Billing Period Start': 'Facturation Période Commencer',
        'Billing Period End': 'Facturation Période Fin',
        Quantity: 'Quantité',
        Price: 'Prix',
        Amount: 'Quantité',
        Subtotal: 'Sous-total',
        'VAT Output Tax': 'TVA Sortie Taxe',
        'Total Amount Payable': 'Total Quantité Payable',
        'Please make sure to pay on or before the payment due date above':
            'Veuillez vous assurer de payer au plus tard à la date d’échéance du paiement ci-dessus',
        'Send money to the following account': 'Envoyer de l’argent sur le compte suivant',
        'Account Name': 'Compte Nom',
        'Bank Name': 'Banque Nom',
        'Bank Address': 'Banque Adresse',
        'RMB Account': 'RMB Compte',
        // button
        'Toggle Navigation': 'Cabillot Navigation',
        // working calendar
        'Working Days': 'Travaillant Jours',
        'Non Working Days': 'Non Travaillant Jours',
        'Select Row': 'Veuillez sélectionner la ligne de données',
        // Offline Meter Input
        'Daily Value': 'Quotidien Valeur',
        Date: 'Date',
        'Successfully Saved': 'Avec succès Sauvé',
        'Previous Data Is Empty': 'Précédent Les données sont vides',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': 'Administrator session not found',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': 'Administrator session timeout',
        'API.ADVANCED_REPORT_NOT_FOUND': 'Advanced report not found',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': 'Bad request',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': 'Cannot set existing submeter as master meter',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS': 'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': 'Combined equipment equipment relation exists',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND': 'Combined equipment equipment relation not found',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': 'Combined equipment meter relation exists',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': 'Combined equipment meter relation not found',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Combined equipment name is already in use',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': 'Combined equipment not found',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Combined equipment offline meter relation exists',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Combined equipment offline meter relation not found',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Combined equipment parameter name is already in use',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Combined equipment parameter not found or not match',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Combined equipment virtual meter relation exists',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Combined equipment virtual meter relation not found',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not  found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': 'Contact name is already in use',
        'API.CONTACT_NOT_FOUND': 'Contact not found',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': 'Cost center external id exists',
        'API.COST_CENTER_NAME_EXISTS': 'Cost center name exists',
        'API.COST_CENTER_NOT_FOUND': 'Cost center not found',
        'API.COST_FILE_NOT_FOUND': 'Cost file not found',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': 'Data source name is already in use',
        'API.DATA_SOURCE_NOT_FOUND': 'Data source not found',
        'API.DATABASE_ERROR': 'Database error',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': 'Date Is Already In Working Calendar',
        'API.DATE_LOCAL_NOT_FOUND': 'Date local not found',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': 'Distribution circuit name is already in use',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': 'Distribution circuit not found',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': 'Distribution circuit point relation exists',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': 'Distribution circuit point relation not found',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': 'Distribution system name is already in use',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': 'Distribution system not found',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': 'Email is already in use',
        'API.EMAIL_MESSAGE_NOT_FOUND': 'Email message not found',
        'API.EMAIL_NOT_FOUND': 'Email not found',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': 'Email server host is already in use',
        'API.EMAIL_SERVER_NOT_FOUND': 'Email server not found',
        'API.EMPTY_VARIABLES_ARRAY': 'Empty variables array',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': 'Energy category name is already in use',
        'API.ENERGY_CATEGORY_NOT_FOUND': 'Energy category not found',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': 'Energy category used in energy items',
        'API.ENERGY_CATEGORY_USED_IN_METER': 'Energy category used in meter',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': 'Energy category used in offline meter',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': 'Energy category used in tariffs',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': 'Energy category used in virtual meter',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': 'Energy flow diagram link is already in use',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram link not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE': 'Energy flow diagram node name is already in use',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH': 'Energy flow diagram node not found or not match',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': 'Energy flow diagram not found',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item does not belong to energy category',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': 'Energy item is not belong to energy category',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': 'Energy item name is already in use',
        'API.ENERGY_ITEM_NOT_FOUND': 'Energy item not found',
        'API.ENERGY_ITEM_USED_IN_METER': 'Energy item used in meter',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': 'Energy item used in offline meter',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': 'Energy item used in virtual meter',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': 'Equipment meter relation exists',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': 'Equipment meter relation not found',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': 'Equipment name is already in use',
        'API.EQUIPMENT_NOT_FOUND': 'Equipment not found',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': 'Equipment offline meter relation exists',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': 'Equipment offline meter relation not found',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': 'Equipment parameter name is already in use',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': 'Equipment parameter not found or not match',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': 'Equipment virtual meter relation exists',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Equipment virtual meter relation not found',
        'API.ERROR': 'Error',
        'API.EXCEPTION': 'Exception',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': 'Failed to restore cost file',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': 'Failed to restore knowledge file',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': 'Failed to restore offline meter file',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': 'Failed to save offline meter file',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': 'Failed to upload cost file',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': 'Failed to upload knowledge file',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': 'Failed to upload offline meter file',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': 'Gateway name is already in use',
        'API.GATEWAY_NOT_FOUND': 'Gateway not found',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': 'Invalid ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': 'Invalid address',
        'API.INVALID_ADDRESS_VALUE': 'Invalid address value',
        'API.INVALID_ADVANCED_REPORT_ID': 'Invalid advanced report id',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': 'Invalid area value',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': 'Invalid base period end datetime',
        'API.INVALID_BASE_PERIOD_START_DATETIME': 'Invalid base period start datetime',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': 'Invalid baud rate',
        'API.INVALID_BUILDINGS_VALUE': 'Invalid buildings value',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': 'Invalid category',
        'API.INVALID_CHANNEL': 'Invalid channel',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': 'Invalid combined equipment id',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': 'Invalid combined equipment name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': 'Invalid combined equipment parameter id',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': 'Invalid combined equipment parameter name',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': 'Invalid combined equipment parameter type',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': 'Invalid combined equipment uuid',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': 'Invalid connection',
        'API.INVALID_CONSTANT_VALUE': 'Invalid constant value',
        'API.INVALID_CONTACT_ID': 'Invalid contact id',
        'API.INVALID_CONTACT_NAME': 'Invalid contact name',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': 'Invalid cost center id',
        'API.INVALID_COST_FILE_ID': 'Invalid cost file id',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': 'Invalid data source id',
        'API.INVALID_DATA_SOURCE_NAME': 'Invalid data source name',
        'API.INVALID_DATA_SOURCE_PROTOCOL': 'Invalid data source protocol',
        'API.INVALID_DATE_LOCAL': 'Invalid date local',
        'API.INVALID_DENOMINATOR_METER_UUID': 'Invalid denominator meter uuid',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': 'Invalid display name',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': 'Invalid distribution circuit id',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': 'Invalid distribution circuit name',
        'API.INVALID_DISTRIBUTION_ROOM': 'Invalid distribution room',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': 'Invalid distribution system id',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': 'Invalid distribution system name',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': 'Invalid email',
        'API.INVALID_EMAIL_MESSAGE_ID': 'Invalid email message id',
        'API.INVALID_EMAIL_SERVER_HOST': 'Invalid email server host',
        'API.INVALID_EMAIL_SERVER_ID': 'Invalid email server id',
        'API.INVALID_END_DATE_FORMAT': 'Invalid end date format',
        'API.INVALID_END_DATETIME': 'Invalid end datetime',
        'API.INVALID_ENERGY_CATEGORY_ID': 'Invalid energy category id',
        'API.INVALID_ENERGY_CATEGORY_NAME': 'Invalid energy category name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': 'Invalid energy flow diagram id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': 'Invalid energy flow diagram link id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': 'Invalid energy flow diagram name',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': 'Invalid energy flow diagram node id',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': 'Invalid energy flow diagram node name',
        'API.INVALID_ENERGY_ITEM_ID': 'Invalid energy item id',
        'API.INVALID_ENERGY_ITEM_NAME': 'Invalid energy item name',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': 'Invalid equation in expression',
        'API.INVALID_EQUIPMENT_ID': 'Invalid equipment id',
        'API.INVALID_EQUIPMENT_NAME': 'Invalid equipment name',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': 'Invalid equipment parameter id',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': 'Invalid equipment parameter name',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': 'Invalid equipment parameter type',
        'API.INVALID_EQUIPMENT_UUID': 'Invalid equipment uuid',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': 'Invalid expression',
        'API.INVALID_EXPRESSION_OBJECT': 'Invalid expression object',
        'API.INVALID_FDD_CODE': 'Invalid fdd code',
        'API.INVALID_FLOORS_VALUE': 'Invalid floors value',
        'API.INVALID_FROM_ADDR': 'Invalid from addr',
        'API.INVALID_GATEWAY_ID': 'Invalid gateway id',
        'API.INVALID_GATEWAY_NAME': 'Invalid gateway name',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': 'Invalid hourly high limit value',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': 'Invalid hourly low limit value',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': 'Invalid is admin value',
        'API.INVALID_IS_COST_DATA_DISPLAYED': 'Invalid is cost data displayed',
        'API.INVALID_IS_COUNTED_VALUE': 'Invalid is counted value',
        'API.INVALID_IS_ENABLED': 'Invalid is enabled',
        'API.INVALID_IS_HIDDEN': 'Invalid is hidden',
        'API.INVALID_IS_IN_LEASE_VALUE': 'Invalid is in lease value',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': 'Invalid is input counted value',
        'API.INVALID_IS_KEY_TENANT_VALUE': 'Invalid is key tenant value',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': 'Invalid is output counted value',
        'API.INVALID_IS_OUTPUT_VALUE': 'Invalid is output value',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': 'Invalid is trend value',
        'API.INVALID_IS_VIRTUAL_VALUE': 'Invalid is virtual value',
        'API.INVALID_KGCE': 'Invalid kgce',
        'API.INVALID_KGCO2E': 'Invalid kgco2e',
        'API.INVALID_KNOWLEDGE_FILE_ID': 'Invalid knowledge file id',
        'API.INVALID_LATITUDE_VALUE': 'Invalid latitude value',
        'API.INVALID_LEASE_NUMBER_VALUE': 'Invalid lease number value',
        'API.INVALID_LONGITUDE_VALUE': 'Invalid longitude value',
        'API.INVALID_LOW_LIMIT_VALUE': 'Invalid low limit value',
        'API.INVALID_MASTER_METER_ID': 'Invalid master meter id',
        'API.INVALID_MENU_ID': 'Invalid menu id',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': 'Invalid message template',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': 'Invalid meter id',
        'API.INVALID_METER_NAME': 'Invalid meter name',
        'API.INVALID_METER_UUID': 'Invalid meter uuid',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID': 'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME': 'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': 'Invalid name value',
        'API.INVALID_NEW_PASSWORD': 'Invalid new password',
        'API.INVALID_NON_WORKING_DAY_ID': 'Invalid non working day ID',
        'API.INVALID_NOTIFICATION_ID': 'Invalid notification id',
        'API.INVALID_NUMERATOR_METER_UUID': 'Invalid numerator meter uuid',
        'API.INVALID_OBJECT_TYPE': 'Invalid object type',
        'API.INVALID_OFFLINE_METER_DATA': 'Invalid offline meter data',
        'API.INVALID_OFFLINE_METER_FILE_ID': 'Invalid offline meter file id',
        'API.INVALID_OFFLINE_METER_ID': 'Invalid offline meter id',
        'API.INVALID_OFFLINE_METER_NAME': 'Invalid offline meter name',
        'API.INVALID_OFFLINE_METER_UUID': 'Invalid offline meter uuid',
        'API.INVALID_OFFSET_CONSTANT_VALUE': 'Invalid offset constant value',
        'API.INVALID_OLD_PASSWORD': 'Invalid old password',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': 'Invalid parent space id',
        'API.INVALID_PASSWORD': 'Invalid password',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': 'Invalid peak current',
        'API.INVALID_PEAK_LOAD': 'Invalid peak load',
        'API.INVALID_PERIOD_TYPE': 'Invalid period type',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': 'Invalid point id',
        'API.INVALID_POINT_NAME': 'Invalid point name',
        'API.INVALID_PORT': 'Invalid port',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': 'Invalid priority',
        'API.INVALID_PRIVILEGE': 'Invalid privilege',
        'API.INVALID_PRIVILEGE_DATA': 'Invalid privilege data',
        'API.INVALID_PRIVILEGE_ID': 'Invalid privilege id',
        'API.INVALID_PRIVILEGE_NAME': 'Invalid privilege name',
        'API.INVALID_RATIO_VALUE': 'Invalid ratio value',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': 'Invalid reply',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': 'Invalid reporting period end datetime',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': 'Invalid reporting period start datetime',
        'API.INVALID_REQUIRES_AUTHENTICATION': 'Invalid requires authentication',
        'API.INVALID_ROOMS_VALUE': 'Invalid rooms value',
        'API.INVALID_RULE_ID': 'Invalid rule id',
        'API.INVALID_RULE_NAME': 'Invalid rule name',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': 'Invalid sensor id',
        'API.INVALID_SENSOR_NAME': 'Invalid sensor name',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': 'Invalid serial port',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': 'Invalid session please re-login',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': 'Invalid shopfloor id',
        'API.INVALID_SHOPFLOOR_NAME': 'Invalid shopfloor name',
        'API.INVALID_SHOPFLOOR_UUID': 'Invalid shopfloor uuid',
        'API.INVALID_SOURCE_NODE_ID': 'Invalid source node id',
        'API.INVALID_SPACE_ID': 'Invalid space id',
        'API.INVALID_SPACE_NAME': 'Invalid space name',
        'API.INVALID_SPACE_UUID': 'Invalid space uuid',
        'API.INVALID_START_DATE_FORMAT': 'Invalid start date format',
        'API.INVALID_START_DATETIME': 'Invalid start datetime',
        'API.INVALID_STATUS': 'Invalid status',
        'API.INVALID_STORE_ID': 'Invalid store id',
        'API.INVALID_STORE_NAME': 'Invalid store name',
        'API.INVALID_STORE_TYPE_DESCRIPTION': 'Invalid store type description',
        'API.INVALID_STORE_TYPE_ID': 'Invalid store type id',
        'API.INVALID_STORE_TYPE_NAME': 'Invalid store type name',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': 'Invalid store type simplified code',
        'API.INVALID_STORE_UUID': 'Invalid store uuid',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': 'Invalid SVG',
        'API.INVALID_SWITCHGEAR': 'Invalid switchgear',
        'API.INVALID_TARGET_NODE_ID': 'Invalid target node id',
        'API.INVALID_TARIFF_BLOCK_PRICING': 'Invalid tariff block pricing',
        'API.INVALID_TARIFF_ID': 'Invalid tariff id',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': 'Invalid tariff time of use pricing',
        'API.INVALID_TARIFF_TYPE': 'Invalid tariff type',
        'API.INVALID_TENANT_ID': 'Invalid tenant id',
        'API.INVALID_TENANT_NAME': 'Invalid tenant name',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': 'Invalid tenant type description',
        'API.INVALID_TENANT_TYPE_ID': 'Invalid tenant type id',
        'API.INVALID_TENANT_TYPE_NAME': 'Invalid tenant type name',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': 'Invalid tenant type simplified code',
        'API.INVALID_TENANT_UUID': 'Invalid tenant uuid',
        'API.INVALID_TEXT_MESSAGE_ID': 'Invalid text message id',
        'API.INVALID_TIMEZONE_ID': 'Invalid timezone id',
        'API.INVALID_TOKEN': 'Invalid token',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': 'Invalid unit of measure',
        'API.INVALID_UNIT_OF_PRICE': 'Invalid unit of price',
        'API.INVALID_UNITS': 'Invalid units',
        'API.INVALID_USER_ID': 'Invalid user id',
        'API.INVALID_USER_NAME': 'Invalid user name',
        'API.INVALID_USER_NAME_OR_EMAIL': 'Invalid user name or email',
        'API.INVALID_USER_PHONE': 'Invalid user phone',
        'API.INVALID_USER_PLEASE_RE_LOGIN': 'Invalid user please re-login',
        'API.INVALID_USER_UUID': 'Invalid user uuid',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': 'Invalid variable meter id',
        'API.INVALID_VARIABLE_METER_TYPE': 'Invalid variable meter type',
        'API.INVALID_VARIABLE_NAME': 'Invalid variable name',
        'API.INVALID_VERIFICATION_CODE': 'Invalid verification code',
        'API.INVALID_VIRTUAL_METER_ID': 'Invalid virtual meter id',
        'API.INVALID_VIRTUAL_METER_NAME': 'Invalid virtual meter name',
        'API.INVALID_VIRTUAL_METER_UUID': 'Invalid virtual meter uuid',
        'API.INVALID_WEB_MESSAGE_ID': 'Invalid web message id',
        'API.INVALID_WECHAT_MESSAGE_ID': 'Invalid wechat message id',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': 'Invalid working calendar id ',
        'API.INVALID_WORKING_CALENDAR_NAME': 'Invalid working calendar name',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': 'Knowledge File Cannot be Removed from Disk',
        'API.KNOWLEDGE_FILE_NOT_FOUND': 'Knowledge file not found',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY':
            'Master meter does not belong to same energy category',
        'API.MASTER_METER_NOT_FOUND': 'Master meter not found',
        'API.MENU_NOT_FOUND': 'Menu not found',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': 'Meter name is already in use',
        'API.METER_NOT_FOUND': 'Meter not found',
        'API.METER_OF_VARIABLE_NOT_FOUND': 'Meter of variable not found',
        'API.METER_POINT_RELATION_EXISTS': 'Meter point relation exists',
        'API.METER_POINT_RELATION_NOT_FOUND': 'Meter point relation not found',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE': 'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE': 'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE': 'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND': 'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'New password length cannot exceed 100 characters',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': 'Non working day non found',
        'API.NOT_FOUND': 'Not found',
        'API.NOTIFICATION_NOT_FOUND': 'Notification not found',
        'API.OFFLINE_METER_FILE_NOT_FOUND': 'Offline meter file not found',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': 'Offline meter name is already in use',
        'API.OFFLINE_METER_NOT_FOUND': 'Offline meter not found',
        'API.INVALID_OFFLINE_METER_VALUE': 'Ungültiger Offline-Zählerwert',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': 'Offline meter of variable not found',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Old password length cannot exceed 100 characters',
        'API.PARENT_SPACE_NOT_FOUND': 'Parent space not found',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': 'Password length cannot exceed 100 characters',
        'API.PASSWORDS_MATCH': 'New password is the same as the old password',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE': 'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': 'Point name is already in use',
        'API.POINT_NOT_FOUND': 'Point not found',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': 'Privilege name is already in use',
        'API.PRIVILEGE_NOT_FOUND': 'Privilege not found',
        'API.RULE_NAME_IS_ALREADY_IN_USE': 'Rule name is already in use',
        'API.RULE_NOT_FOUND': 'Rule not found',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': 'Sensor name is already in use',
        'API.SENSOR_NOT_FOUND': 'Sensor not found',
        'API.SENSOR_POINT_RELATION_EXISTS': 'Sensor point relation exists',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': 'Sensor point relation not found',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': 'Shopfloor equipment relation exists',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': 'Shopfloor equipment relation not found',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': 'Shopfloor meter relation exists',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': 'Shopfloor meter relation not found',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': 'Shopfloor name is already in use',
        'API.SHOPFLOOR_NOT_FOUND': 'Shopfloor not found',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': 'Shopfloor offline meter relation exists',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': 'Shopfloor offline meter relation not found',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': 'Shopfloor point relation exists',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': 'Shopfloor point relation not found',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': 'Shopfloor sensor relation exists',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': 'Shopfloor sensor relation not found',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': 'Shopfloor virtual meter relation exists',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': 'Shopfloor virtual meter relation not found',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': 'Shopfloor working calendar relation exists',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Shopfloor working calendar relation not found',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': 'Source node not found',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': 'Space combined equipment relation exists',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': 'Space combined equipment relation not found',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS': 'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': 'Space equipment relation exists',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': 'Space equipment relation not found',
        'API.SPACE_METER_RELATION_EXISTS': 'Space meter relation exists',
        'API.SPACE_METER_RELATION_NOT_FOUND': 'Space meter relation not found',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': 'Space name is already in use',
        'API.SPACE_NOT_FOUND': 'Space not found',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': 'Space not found in privilege',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': 'Space offline meter relation exists',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': 'Space offline meter relation not found',
        'API.SPACE_POINT_RELATION_EXISTS': 'Space point relation exists',
        'API.SPACE_POINT_RELATION_NOT_FOUND': 'Space point relation not found',
        'API.SPACE_SENSOR_RELATION_EXISTS': 'Space sensor relation exists',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': 'Space sensor relation not found',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': 'Space shopfloor relation exists',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': 'Space shopfloor relation not found',
        'API.SPACE_STORE_RELATION_EXISTS': 'Space store relation exists',
        'API.SPACE_STORE_RELATION_NOT_FOUND': 'Space store relation not found',
        'API.SPACE_TENANT_RELATION_EXISTS': 'Space tenant relation exists',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': 'Space tenant relation not found',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': 'Space virtual meter relation exists',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Space virtual meter relation not found',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': 'Space working calendar relation exists',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Space working calendar relation not found',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME': 'Start datetime must be early than end datetime',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': 'Store meter relation exists',
        'API.STORE_METER_RELATION_NOT_FOUND': 'Store meter relation not found',
        'API.STORE_NAME_IS_ALREADY_IN_USE': 'Store name is already in use',
        'API.STORE_NOT_FOUND': 'Store not found',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': 'Store offline meter relation exists',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': 'Store offline meter relation not found',
        'API.STORE_POINT_RELATION_EXISTS': 'Store point relation exists',
        'API.STORE_POINT_RELATION_NOT_FOUND': 'Store point relation not found',
        'API.STORE_SENSOR_RELATION_EXISTS': 'Store sensor relation exists',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': 'Store sensor relation not found',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': 'Store type name is already in use',
        'API.STORE_TYPE_NOT_FOUND': 'Store type not found',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Store type simplified code is already in use',
        'API.STORE_TYPE_USED_IN_STORE': 'Store type used in store',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': 'Store virtual meter relation exists',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': 'Store virtual meter relation not found',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': 'Store working calendar relation exists',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Store working calendar relation not found',
        'API.TARGET_NODE_NOT_FOUND': 'Target node not found',
        'API.TARIFF_IN_USE': 'Tariff in use',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': 'Tariff is already associated with cost center',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': 'Tariff is not associated with cost center',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': 'Tariff name is already in use',
        'API.TARIFF_NOT_FOUND': 'Tariff not found',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation  not found',
        'API.TENANT_METER_RELATION_EXISTS': 'Tenant meter relation exists',
        'API.TENANT_METER_RELATION_NOT_FOUND': 'Tenant meter relation not found',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': 'Tenant name is already in use',
        'API.TENANT_NOT_FOUND': 'Tenant not found',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': 'Tenant offline meter relation exists',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': 'Tenant offline meter relation not found',
        'API.TENANT_POINT_RELATION_EXISTS': 'Tenant point relation exists',
        'API.TENANT_POINT_RELATION_NOT_FOUND': 'Tenant point relation not found',
        'API.TENANT_SENSOR_RELATION_EXISTS': 'Tenant sensor relation exists',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': 'Tenant sensor relation not found',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': 'Tenant type name is already in use',
        'API.TENANT_TYPE_NOT_FOUND': 'Tenant type not found',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': 'Tenant type simplified code is already in use',
        'API.TENANT_TYPE_USED_IN_TENANT': 'Tenant type used in tenant',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': 'Tenant virtual meter relation exists',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': 'Tenant virtual meter relation not found',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': 'Tenant working calendar relation exists',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': 'Tenant working calendar relation not found',
        'API.TEXT_MESSAGE_NOT_FOUND': 'Text message not found',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES': 'The reporting period must be longer than 15 minutes',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': 'There is relation with child meters',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': 'There is relation with children spaces',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS':
            'There is relation with combined equipment parameters',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': 'There is relation with combined equipments',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': 'There is relation with data sources',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS': 'There is relation with energy flow diagram links',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': 'There Is Relation With Energy Storage Containers Batteries',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': 'There Is Relation With Energy Storage Containers Grids',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': 'There Is Relation With Energy Storage Containers Loads',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': 'There Is Relation With Energy Storage Containers Power Conversion Systems',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': 'There is relation with equipment parameters',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': 'There is relation with equipments',
        'API.THERE_IS_RELATION_WITH_METER': 'There is relation with meter',
        'API.THERE_IS_RELATION_WITH_METERS': 'There is relation with meters',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': 'There is relation with offline meter',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': 'There is relation with offline meters',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': 'There is relation with other virtual meters',
        'API.THERE_IS_RELATION_WITH_SENSORS': 'There is relation with sensors',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': 'There is relation with shopfloors',
        'API.THERE_IS_RELATION_WITH_SPACES': 'There is relation with spaces',
        'API.THERE_IS_RELATION_WITH_STORES': 'There is relation with stores',
        'API.THERE_IS_RELATION_WITH_TENANTS': 'There is relation with tenants',
        'API.THERE_IS_RELATION_WITH_USERS': 'There is relation with users',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': 'There is relation with virtual meter',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': 'Relation avec la centrale électrique virtuelle',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': 'This data source is being used by a meter',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This meter is being used by a virtual meter',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': 'This offline meter is being used by a virtual meter',
        'API.THIS_SPACE_CANNOT_BE_CLONED': 'This space cannot be cloned',
        'API.THIS_SPACE_CANNOT_BE_DELETED': 'This space cannot be deleted',
        'API.TIMEZONE_NOT_FOUND': 'Timezone not found',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'Token not found in headers please login',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': 'User Account Has Been Locked',
        'API.USER_ACCOUNT_HAS_EXPIRED': 'User Account Has Expired',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': 'User name is already in use',
        'API.USER_NOT_FOUND': 'User not found',
        'API.USER_PASSWORD_HAS_EXPIRED': 'User Password Has Expired',
        'API.USER_PRIVILEGE_NOT_FOUND': 'User privilege not found',
        'API.USER_SESSION_NOT_FOUND': 'User session not found',
        'API.USER_SESSION_TIMEOUT': 'User session timeout',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': 'User uuid not found in headers please login',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': 'Virtual meter name is already in use',
        'API.VIRTUAL_METER_NOT_FOUND': 'Virtual meter not found',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': 'Virtual meter of variable not found',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': 'Virtual point should be analog value',
        'API.WEB_MESSAGE_NOT_FOUND': 'Web message not found',
        'API.WECHAT_MESSAGE_NOT_FOUND': 'Wechat message not found',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': 'Working calendar name is already in use',
        'API.WORKING_CALENDAR_NOT_FOUND': 'Working calendar not found',

        MasterMeter: 'Tableau récapitulatif',
        SubMeter: 'Sous - table',
        'Power Quality': 'Calidad de energía',
        'About Power Quality': 'Acerca de la calidad de energía',
        'Trend Values': 'Valores de tendencia',
        Category: 'Categoría',
        Type: 'Tipo',
        Unit: 'Unidad',
        Limit: 'Límite',
        'Normal Limit': 'Límite normal',
        'Severe Limit': 'Límite severo',
        Compliance: 'Tasa de cumplimiento',
        'Worst Deviation': 'Peor desviación',
        'Worst Time': 'Momento de peor desviación',
        'Severe Exceed Count': 'Conteo de excedencias severas',
        'Worst Unbalance': 'Desbalance máximo',
        Hz: 'Hz',
        voltage: 'Tensión',
        current: 'Corriente',
        frequency: 'Frecuencia',
        voltage_deviation: 'Desviación de tensión',
        current_unbalance: 'Desequilibrio de corriente',
        voltage_unbalance: 'Desequilibrio de tensión',
        mean_deviation_pct: 'Desviación media (%)',
        p95_abs_deviation_pct: 'Desviación absoluta P95 (%)',
        mean_abs_deviation_hz: 'Desviación absoluta media (Hz)',
        frequency_deviation: 'Desviación de frecuencia',
        p95_abs_deviation_hz: 'Desviación absoluta P95 (Hz)',
        mean_unbalance_pct: 'Desequilibrio medio (%)',
        p95_unbalance_pct: 'Desequilibrio P95 (%)',
        count: 'Recuento',
        min: 'Mín',
        max: 'Máx',
        mean: 'Media',
        std: 'Desv. est.',
        p5: 'P5',
        p95: 'P95'
    }
};
